import React from 'react';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AddIconSimple from '@material-ui/icons/Add';
import AddIcon from '@material-ui/icons/AddCircle';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import AppsIcon from '@material-ui/icons/Apps';
import ArchiveIcon from '@material-ui/icons/Archive';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BlockIcon from '@material-ui/icons/Block';
import BusinessIcon from '@material-ui/icons/Business';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import CheckIcon from '@material-ui/icons/Check';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import TrashIcon from '@material-ui/icons/Delete';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FacebookIcon from '@material-ui/icons/Facebook';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import FilterListIcon from '@material-ui/icons/FilterList';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import GifIcon from '@material-ui/icons/Gif';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import ImageIcon from '@material-ui/icons/Image';
import InfoIcon from '@material-ui/icons/Info';
import InstagramIcon from '@material-ui/icons/Instagram';
import LaunchIc from '@material-ui/icons/Launch';
import LinkIcon from '@material-ui/icons/Link';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MailIcon from '@material-ui/icons/Mail';
import Menu from '@material-ui/icons/Menu';
import MenuOpen from '@material-ui/icons/MenuOpen';
import MoreVert from '@material-ui/icons/MoreVert';
import PageView from '@material-ui/icons/PageviewOutlined';
import PanToolIcon from '@material-ui/icons/PanTool';
import PeopleIcon from '@material-ui/icons/People';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PinterestIcon from '@material-ui/icons/Pinterest';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import PrintIcon from '@material-ui/icons/Print';
import PublicIc from '@material-ui/icons/Public';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Refresh from '@material-ui/icons/Refresh';
import RemoveIcon from '@material-ui/icons/Remove';
import RepeatIcon from '@material-ui/icons/Repeat';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import SearchIcon from '@material-ui/icons/Search';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SettingsIcon from '@material-ui/icons/Settings';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SpeakerIcon from '@material-ui/icons/Speaker';
import SpeedIcon from '@material-ui/icons/Speed';
import SportsIcon from '@material-ui/icons/Sports';
import StarIcon from '@material-ui/icons/Star';
import StarsIcon from '@material-ui/icons/Stars';
import StorefrontIcon from '@material-ui/icons/Storefront';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TuneIcon from '@material-ui/icons/Tune';
import TwitterIcon from '@material-ui/icons/Twitter';
import UndoIcon from '@material-ui/icons/Undo';
import UpdateIcon from '@material-ui/icons/Update';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import WarningIcon from '@material-ui/icons/Warning';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import WorkIcon from '@material-ui/icons/Work';
export const MyReceiptIcon = props => /*#__PURE__*/React.createElement(ReceiptIcon, props);
export const MySettingsIcon = props => /*#__PURE__*/React.createElement(SettingsIcon, props);
export const MyWorkIcon = props => /*#__PURE__*/React.createElement(WorkIcon, props);
export const MyTuneIcon = props => /*#__PURE__*/React.createElement(TuneIcon, props);
export const LockOpen = props => /*#__PURE__*/React.createElement(LockOpenIcon, props);
export const MyInfoIcon = props => /*#__PURE__*/React.createElement(InfoIcon, props);
export const MyBlockIcon = props => /*#__PURE__*/React.createElement(BlockIcon, props);
export const AddSimpleIcon = props => /*#__PURE__*/React.createElement(AddIconSimple, props);
export const LeftIcon = props => /*#__PURE__*/React.createElement(ChevronLeftIcon, props);
export const RightIcon = props => /*#__PURE__*/React.createElement(ChevronRightIcon, props);
export const DropDownIcon = props => /*#__PURE__*/React.createElement(ArrowDropDownCircleIcon, props);
export const DropUpIcon = props => /*#__PURE__*/React.createElement(ArrowDropUpIcon, props);
export const MyGifIcon = props => /*#__PURE__*/React.createElement(GifIcon, props);
export const WorkoutIcon = props => /*#__PURE__*/React.createElement(FitnessCenterIcon, props);
export const LibraryIcon = props => /*#__PURE__*/React.createElement(LocalLibraryIcon, props);
export const MySportIcon = props => /*#__PURE__*/React.createElement(SportsIcon, props);
export const MyWhatsAppIcon = props => /*#__PURE__*/React.createElement(WhatsAppIcon, props);
export const ArrowForwardIcon = props => /*#__PURE__*/React.createElement(ArrowForward, props);
const MySpeakerIcon = props => /*#__PURE__*/React.createElement(SpeakerIcon, props);
export const ServiceIcon = props => /*#__PURE__*/React.createElement(RepeatOneIcon, props);
export const CourseIcon = props => /*#__PURE__*/React.createElement(RepeatIcon, props);
export const EventIcon = props => /*#__PURE__*/React.createElement(EmojiEventsIcon, props);
export const MyPrintIcon = props => /*#__PURE__*/React.createElement(PrintIcon, props);
export const MyPeopleIcon = props => /*#__PURE__*/React.createElement(PeopleIcon, props);
export const FiltersIcon = props => /*#__PURE__*/React.createElement(FilterListIcon, props);
export const MyPhoneIcon = props => /*#__PURE__*/React.createElement(PhoneIcon, props);
export const MyEmailIcon = props => /*#__PURE__*/React.createElement(EmailIcon, props);
export const MyArchiveIcon = props => /*#__PURE__*/React.createElement(ArchiveIcon, props);
export const ProfileBusinessIcon = props => /*#__PURE__*/React.createElement(BusinessCenterIcon, props);
export const CatalogoIcon = props => /*#__PURE__*/React.createElement(StorefrontIcon, props);
export const ClientsIcon = props => /*#__PURE__*/React.createElement(PermContactCalendarIcon, props);
export const MyAssignmentIcon = props => /*#__PURE__*/React.createElement(AssignmentIcon, props);
export const OverviewIcon = props => /*#__PURE__*/React.createElement(SpeedIcon, props);
export const UsersIcon = props => /*#__PURE__*/React.createElement(SupervisorAccountIcon, props);
export const MembershipIcon = props => /*#__PURE__*/React.createElement(AssignmentIndIcon, props);
export const PaymentCardIcon = props => /*#__PURE__*/React.createElement(CreditCardIcon, props);
export const CalendarIcon = props => /*#__PURE__*/React.createElement(EventAvailableIcon, props);
export const CentersIcon = props => /*#__PURE__*/React.createElement(BusinessIcon, props);
export const SadIcon = props => /*#__PURE__*/React.createElement(SentimentVeryDissatisfiedIcon, props);
const AddIconTyx = props => /*#__PURE__*/React.createElement(AddIcon, props);
const EditIconTyx = props => /*#__PURE__*/React.createElement(EditIcon, props);
const CrossIconTyx = props => /*#__PURE__*/React.createElement(CloseIcon, props);
export const DeleteIcon = props => /*#__PURE__*/React.createElement(TrashIcon, props);
const WarningIconTyx = props => /*#__PURE__*/React.createElement(WarningIcon, props);
const UpdateIconTyx = props => /*#__PURE__*/React.createElement(UpdateIcon, props);
export const ProfileIcon = props => /*#__PURE__*/React.createElement(PersonIcon, props);
export const LogOutIcon = props => /*#__PURE__*/React.createElement(ExitToAppIcon, props);
export const MoreIcon = props => /*#__PURE__*/React.createElement(MoreVert, props);
export const RefreshIcon = props => /*#__PURE__*/React.createElement(Refresh, props);
export const PreviewIcon = props => /*#__PURE__*/React.createElement(PageView, props);
const ExpandMoreIconTyx = props => /*#__PURE__*/React.createElement(ExpandMoreIcon, props);
export const VisibilityIconOn = props => /*#__PURE__*/React.createElement(VisibilityIcon, props);
export const VisibilityIconOff = props => /*#__PURE__*/React.createElement(VisibilityOffIcon, props);
const ExpandLessIconTyx = props => /*#__PURE__*/React.createElement(ExpandLessIcon, props);
export const ListViewIcon = props => /*#__PURE__*/React.createElement(FormatListBulletedIcon, props);
export const ListViewIconWithNumbers = props => /*#__PURE__*/React.createElement(FormatListNumberedIcon, props);
export const CardViewIcon = props => /*#__PURE__*/React.createElement(AppsIcon, props);
export const SuccessDoneIcon = props => /*#__PURE__*/React.createElement(DoneIcon, props);
export const PdfIcon = props => /*#__PURE__*/React.createElement(PictureAsPdfIcon, props);
export const ImgIcon = props => /*#__PURE__*/React.createElement(ImageIcon, props);
export const PlayIcon = props => /*#__PURE__*/React.createElement(PlayCircleFilledIcon, props);
export const RestoreIcon = props => /*#__PURE__*/React.createElement(UndoIcon, props);
export const FileIcon = props => /*#__PURE__*/React.createElement(FileCopyIcon, props);
export const GroupIcon = props => /*#__PURE__*/React.createElement(GroupWorkIcon, props);
export const LocationIcon = props => /*#__PURE__*/React.createElement(LocationOnIcon, props);
const GyAddOutlinedIcon = props => /*#__PURE__*/React.createElement(AddOutlinedIcon, props);
const FacebookIconGy = props => /*#__PURE__*/React.createElement(FacebookIcon, props);
const TwitterIconGy = props => /*#__PURE__*/React.createElement(TwitterIcon, props);
const InstagramIconGy = props => /*#__PURE__*/React.createElement(InstagramIcon, props);
const PinterestIconGy = props => /*#__PURE__*/React.createElement(PinterestIcon, props);
const LinkedInIconGy = props => /*#__PURE__*/React.createElement(LinkedInIcon, props);
const SearchIconGy = props => /*#__PURE__*/React.createElement(SearchIcon, props);
const CheckIconGy = props => /*#__PURE__*/React.createElement(CheckIcon, props);
export const ArrowRightIcon = props => /*#__PURE__*/React.createElement(ArrowForwardIosIcon, props);
const StarIconGy = props => /*#__PURE__*/React.createElement(StarIcon, props);
export const BarChartIcon = props => /*#__PURE__*/React.createElement(AssessmentIcon, props);
const VideoLibraryIconGy = props => /*#__PURE__*/React.createElement(VideoLibraryIcon, props);
const ShoppingCartIconGy = props => /*#__PURE__*/React.createElement(ShoppingCartIcon, props);
const LockIconGy = props => /*#__PURE__*/React.createElement(LockIcon, props);
export const VideoIcon = props => /*#__PURE__*/React.createElement(VideoLibraryIcon, props);
const MailIconGy = props => /*#__PURE__*/React.createElement(MailIcon, props);
const LinkIconGy = props => /*#__PURE__*/React.createElement(LinkIcon, props);
const DirectionsWalkIconGy = props => /*#__PURE__*/React.createElement(DirectionsWalkIcon, props);
export const MenuIcon = props => /*#__PURE__*/React.createElement(Menu, props);
export const MenuOpenIcon = props => /*#__PURE__*/React.createElement(MenuOpen, props);
export const WaitingListIcon = props => /*#__PURE__*/React.createElement(PanToolIcon, props);
export const ReimbursedIcon = props => /*#__PURE__*/React.createElement(AccountBalanceWalletIcon, props);
export const SubscriptionsIcon = props => /*#__PURE__*/React.createElement(CardMembershipIcon, props);
export const DownloadIcon = props => /*#__PURE__*/React.createElement(CloudDownloadOutlinedIcon, props);
export const GrowIcon = props => /*#__PURE__*/React.createElement(TrendingUpIcon, props);
export const AllInOnePlanIcon = props => /*#__PURE__*/React.createElement(StarsIcon, props);
export const ArrowBackIcon = props => /*#__PURE__*/React.createElement(ArrowBack, props);
export const PublicIcon = props => /*#__PURE__*/React.createElement(PublicIc, props);
export const LaunchIcon = props => /*#__PURE__*/React.createElement(LaunchIc, props);
export const ReduceIcon = props => /*#__PURE__*/React.createElement(RemoveIcon, props);
export { MySpeakerIcon, AddIconTyx as AddIcon, CrossIconTyx as CrossIcon, DirectionsWalkIconGy as DirectionsWalkIcon, EditIconTyx as EditIcon, ExpandLessIconTyx as ExpandLessIcon, ExpandMoreIconTyx as ExpandMoreIcon, GyAddOutlinedIcon as AddOutlinedIcon, UpdateIconTyx as UpdateIcon, WarningIconTyx as WarningIcon, LinkedInIconGy as LinkedInIcon, FacebookIconGy as FacebookIcon, TwitterIconGy as TwitterIcon, InstagramIconGy as InstagramIcon, PinterestIconGy as PinterestIcon, SearchIconGy as SearchIcon, CheckIconGy as CheckIcon, StarIconGy as StarIcon, VideoLibraryIconGy as VideoLibraryIcon, LockIconGy as LockIcon, ShoppingCartIconGy as ShoppingCartIcon, MailIconGy as MailIcon, LinkIconGy as LinkIcon };